/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateTagsParams } from './UpdateTagsParams';
import {
    UpdateTagsParamsFromJSON,
    UpdateTagsParamsFromJSONTyped,
    UpdateTagsParamsToJSON,
} from './UpdateTagsParams';

/**
 * 
 * @export
 * @interface UpdateTagsBulkParams
 */
export interface UpdateTagsBulkParams {
    /**
     * 
     * @type {{ [key: string]: UpdateTagsParams; }}
     * @memberof UpdateTagsBulkParams
     */
    updatePerProject: { [key: string]: UpdateTagsParams; };
}

/**
 * Check if a given object implements the UpdateTagsBulkParams interface.
 */
export function instanceOfUpdateTagsBulkParams(value: object): value is UpdateTagsBulkParams {
    if (!('updatePerProject' in value) || value['updatePerProject'] === undefined) return false;
    return true;
}

export function UpdateTagsBulkParamsFromJSON(json: any): UpdateTagsBulkParams {
    return UpdateTagsBulkParamsFromJSONTyped(json, false);
}

export function UpdateTagsBulkParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTagsBulkParams {
    if (json == null) {
        return json;
    }
    return {
        
        'updatePerProject': (mapValues(json['updatePerProject'], UpdateTagsParamsFromJSON)),
    };
}

export function UpdateTagsBulkParamsToJSON(value?: UpdateTagsBulkParams | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatePerProject': (mapValues(value['updatePerProject'], UpdateTagsParamsToJSON)),
    };
}

